import React from 'react';
import PropTypes from 'prop-types';
import {
  Button, Card, Elevation, Icon,
} from '@blueprintjs/core';
import { autobind } from 'core-decorators';

class Login extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      redirecting: false,
    };
  }

  @autobind
  onClick() {
    const { onLogin } = this.props;
    this.setState({ redirecting: true });
    Promise.resolve(onLogin())
      .catch(() => this.setState({ redirecting: false }));
  }

  render() {
    const { redirecting } = this.state;
    return (
      <section className="hero is-fullheight">
        <div className="hero-body">
          <div className="container has-text-left">
            <div className="columns">
              <div className="column is-one-third is-offset-one-third">
                <Card elevation={Elevation.FOUR}>
                  <h5 className="bp3-heading"><Icon icon="briefcase" /></h5>
                  <Button
                    intent="success"
                    fill
                    loading={redirecting}
                    disabled={redirecting}
                    onClick={this.onClick}
                  >
                    <Icon icon="log-in" />
                  </Button>
                </Card>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

Login.propTypes = {
  onLogin: PropTypes.func,
};

export default Login;
